import { makeAutoObservable } from 'mobx';
import { clearPersistedStore, makePersistable } from 'mobx-persist-store';

export const LIST_STORE = 'brandListStore';

const defaultStateValues = {
  paginationState: {
    pageIndex: 0,
    pageSize: 10,
  },
  filters: {},
  sorting: {},
};

class BrandListStore {
  params = JSON.stringify({});

  constructor(rootStore) {
    this.rootStore = rootStore;

    makeAutoObservable(this);

    makePersistable(this, {
      name: LIST_STORE,
      properties: ['params'],
    });
  }

  set(newParams) {
    this.params = JSON.stringify({
      ...defaultStateValues,
      ...newParams,
    });
  }

  get() {
    const currentData = JSON.parse(this.params);
    return {
      ...defaultStateValues,
      ...currentData,
    };
  }

  async clearStore() {
    await clearPersistedStore(this);
  }
}

export default BrandListStore;
